import * as React from 'react';
import { useSelector } from 'react-redux';

import { offerSelector } from 'shared/selectors';
import { selectNewbuildingFromDeveloperUrl } from 'shared/selectors/newObject';
import { IAddressInfoSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';
import { IAddressInfo } from 'shared/types/geo/address';

import { getJsonQuery } from './utils';
import { useSaveSearchContext } from '../../../packages/SaveSearchModal';

export const defaultTitleFromAddress = (address: IAddressInfoSchema[] & IAddressInfo[]) => {
  const addressWithoutStreet = address.filter(
    addr => addr.type === 'raion' || addr.type === 'okrug' || addr.type === 'location',
  );

  return addressWithoutStreet.map(a => a.shortName).join(', ');
};

export function useSearchSetParams() {
  const { onOpen, setParams } = useSaveSearchContext();

  const offer = useSelector(offerSelector);
  const defaultTitle = React.useMemo(() => defaultTitleFromAddress(offer.geo.address), [offer.geo.address]);
  const jsonQuery = React.useMemo(() => getJsonQuery(offer), [offer]);
  const queryString = useSelector(selectNewbuildingFromDeveloperUrl);

  const handleClick = React.useCallback(() => {
    const additionalParams = {
      title: defaultTitle,
      modalTitle: 'Подписаться на локацию',
      submitButtonText: 'Подписаться',
      jsonQuery,
      analyticsParams: {
        pageType: 'Card',
        queryString,
        offerId: offer.id,
        isFromBanner: false,
      },
    };

    setParams(additionalParams);

    onOpen();
  }, [defaultTitle, jsonQuery, queryString, offer.id, onOpen, setParams]);

  return { handleClick, offerId: offer.id };
}
